const safetyMRKeys = {
  all: ['SAFETY_MR'],
  listData: () => [...safetyMRKeys.all, 'GET_LIST_DATA'],
  specificDataBase: () => [...safetyMRKeys.all, 'GET_SPECIFIC_DATA'],
  specificData: ({ seq }) => [...safetyMRKeys.specificDataBase(), seq],
};

export default safetyMRKeys;
